<template>
	<nk-page class="h-100" commercialAccess="System">
		<!--		<template #badges>-->
		<!--			<nk-badge system="accounting">-->
		<!--				<nk-badge-item type="system" modelValue="accounting"></nk-badge-item>-->
		<!--			</nk-badge>-->
		<!--		</template>-->

		<div class="overflow-auto h-100 d-flex flex-column form-container">
			<!--			<nk-table v-model="selectedRow" v-if="toggler" :data="tableData" :options="componentOptions.tableOptions" ref="table"></nk-table>-->
			<ag-grid :options="agGridOption" :data="data.executeResult.items" v-model="selectedRow" ref="table"></ag-grid>

		</div>

	</nk-page>
</template>

<script>
	import _ from 'lodash'
	import BooleanLabel from '~/components/form/boolean-label'
	import { helpers } from "@nikan/text-visualizer"
	import { PrintDataConvertTypes } from '@/plugins/stimul'

	export default {
		name: 'DynamicReportViewer',
		props: {
			data: { type: Object, required: true },
			options: Object
		},
		data() {
			return {
				printColumnSettings: {},
				printButton: {
					type: 'print',
					claimPrefix: 'Report_Dynamic_',
					form: 'DynamicReport',
					getDataSources: this.print_dataSources,
					disabled: true
				},
				agGridOption: {
					detailCellRendererParams: {
						detailGridOptions: {
							columnDefs: [],
							nestedFieldName: '',
						}
					},
					groupIncludeTotalFooter: true,
					pagination: true,
					columnDefs: []
				},
				toggler: false,
				selectedRow: {},
				componentOptions: {
					tableOptions: {
						stateUID: 'document',
						multiselection: true,
						editable: false,
						alwaysEmit: true,
						searchable: false,
						allowNewRow: false,
						colIndicatorBarEnabled: false,
						buttons: {},
						columns: [],
					}

				},
				enumGroups: {}
			}
		},
		created() {
			this.prepareEnums()

			if (this.data && this.data.executeResult && this.data.executeResult.items && this.data.executeResult.items.length)
				this.printButton.disabled = false

			this.agGridOption = _.merge(this.agGridOption, this.options)

			this.prepareColumns()
		},
		mounted() {
			this.prepareWindow(this.data.name, [this.printButton])
			this.toggler = true
		},
		methods: {
			print_dataSources() {
				return [
					{
						name: this.data.name,
						data: this.$refs.table.getFilteredTableData(),
						converter: {
							type: PrintDataConvertTypes.MAPPER,
							settings: this.printColumnSettings
						},
					}
				]
			},
			prepareColumns() {
				const rowNumberColumn = {

					field: 'rowNumber',
					contentType: 'number',
					headerName: '...',
					sortable: true,
					resizable: true,
					aggFunc: 'count',
					width: 80,
					// maxWidth: 80
				}
				// const rowNumberColumn = {
				// 	name: 'rowNumber',
				// 	title: '...',
				// 	searchable: true,
				// 	sortable: true,
				// 	editable: true,
				// 	resizable: true,
				// 	pinnable: false,
				// 	pinned: false,
				// 	width: 60,
				// 	entering: (row) => {
				// 		return false
				// 	},
				// 	aggregates: [
				// 		{
				// 			type: 'count'
				// 		},
				// 	],
				// }

				let columns = [rowNumberColumn]
				this.data.executeResult.reportHeaders.forEach(header => {
					const translateEnum = (data) => this.$t('enum-items.' + header.headerType.split('_')[1] + '.' + this.getEnumNameByValue(header.headerType.split('_')[1], data))
					let obj = {
						// type: header.headerType,
						field: header.propName,
						headerName: header.title,
					}
					// let obj = {
					// 	name: header.propName,
					// 	title: header.title,
					// 	type: header.headerType,
					// 	searchable: true,
					// 	sortable: true,
					// 	editable: true,
					// 	resizable: true,
					// 	pinnable: false,
					// 	pinned: false,
					// 	width: 'auto',
					// 	// aggregates: [
					// 	// 	{
					// 	// 		type: 'count'
					// 	// 	},
					// 	// ],
					// }

					if (header.headerType.toLowerCase() === 'datetime') {
						obj.contentType = 'date'
						// obj.type = 'pdate'
						// obj.view = {
						// 	options: {
						// 		type: 'pdate',
						// 		format: 'YYYY/MM/DD',
						// 	},
						// }
					} else if (header.headerType.toLowerCase() === 'decimal') {
						obj.contentType = 'price'
						obj.aggFunc = 'sum'
						// obj.valueFormatter = data => {
						// 	return helpers.formatPrice(Math.abs(data.value))
						// }
						// obj.view = {
						// 	options: {
						// 		type: 'price',
						// 	},
						// }
					} else if (header.headerType.toLowerCase().includes('enum')) {
						obj.contentType = 'enum'
						obj.valueFormatter = (value) => {

							if (typeof value.value === 'number')
								return translateEnum(value.value)
						}

						// obj.view = {
						// 	options: {
						// 		format: (item) => this.$t('enum-items.' + header.headerType.split('_')[1] + '.' + this.getEnumNameByValue(header.headerType.split('_')[1], item)),
						// 	},
						// }
					}
					if (header.headerType.toLowerCase() === 'boolean') {
						obj.cellRenderer = BooleanLabel
						obj.cellRendererParams = (data) => {
							return {
								options: {
									useColors: true,
									modelValue: data.value

								}
							}
						}

					}


					if (header.headerType.toLowerCase().includes('enum')) {
						this.printColumnSettings[header.title] = (item, row) => translateEnum(row[header.propName])
					}
					else {
						this.printColumnSettings[header.title] = (item, row) => row[header.propName]
					}

					columns.push(obj)
				})
				this.agGridOption.columnDefs = columns
				// this.componentOptions.tableOptions.columns = columns

			},
			prepareEnums() {
				for (let header of this.data.executeResult.reportHeaders) {
					if (header.headerType.toLowerCase().indexOf('enum') === -1)
						continue
					let enumGroup = header.headerType.split('_').length > 1 ? header.headerType.split('_')[1] : header.headerType
					this.enumGroups[enumGroup] = this.getPropertiesByGroup(enumGroup)
				}
			},
			getEnumNameByValue(enumGroup, value) {
				if (!this.enumGroups[enumGroup])
					return ""
				return this.enumGroups[enumGroup].find(x => x.value == value)?.name
			}
		}
	}
</script>

<style>
	.bs-wrapper-xs .nk-page-body {
		padding: 0;
	}
</style>
